import React from 'react';

import { API_URL } from '../config';

const IMAGE_PATTERN = /!\[(.*?)\]\((.*?)\)/g;
const SINGLE_IMAGE_PATTERN = /^!\[(.*?)\]\((.*?)\)$/;

const resolveNewsImageUrl = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (/^(https?:)?\/\//i.test(raw) || raw.startsWith('data:') || !raw.startsWith('/')) {
    return raw;
  }
  return `${API_URL}${raw}`;
};

const renderNewsImage = (src, alt, key) => (
  <img
    key={key}
    src={resolveNewsImageUrl(src)}
    alt={alt || 'Изображение новости'}
    className="mx-auto my-3 block h-auto max-h-[70vh] max-w-full rounded-2xl border border-gray-200 bg-white object-contain dark:border-gray-700 dark:bg-gray-900"
  />
);

const renderInline = (text, keyPrefix) => {
  const result = [];
  let lastIndex = 0;
  let match;
  let imageIndex = 0;

  while ((match = IMAGE_PATTERN.exec(text)) !== null) {
    if (match.index > lastIndex) {
      result.push(<span key={`${keyPrefix}-text-${lastIndex}`}>{text.slice(lastIndex, match.index)}</span>);
    }

    result.push(renderNewsImage(match[2], match[1], `${keyPrefix}-img-${imageIndex}`));

    lastIndex = match.index + match[0].length;
    imageIndex += 1;
  }

  if (lastIndex < text.length) {
    result.push(<span key={`${keyPrefix}-text-tail`}>{text.slice(lastIndex)}</span>);
  }

  return result.length ? result : text;
};

const NewsMarkdown = ({ content = '' }) => {
  const blocks = String(content || '').split(/\n\s*\n/).map((block) => block.trim()).filter(Boolean);

  return (
    <div className="space-y-4 text-sm leading-6 text-gray-700 dark:text-gray-200">
      {blocks.map((block, index) => {
        if (block.startsWith('## ')) {
          return <h3 key={index} className="text-lg font-semibold text-gray-900 dark:text-gray-100">{block.slice(3)}</h3>;
        }

        if (block.startsWith('# ')) {
          return <h2 key={index} className="text-xl font-semibold text-gray-900 dark:text-gray-100">{block.slice(2)}</h2>;
        }

        const lines = block.split('\n').map((line) => line.trimRight());
        if (lines.every((line) => line.startsWith('- '))) {
          return (
            <ul key={index} className="space-y-2 pl-5">
              {lines.map((line, lineIndex) => (
                <li key={lineIndex} className="list-disc">{renderInline(line.slice(2), `${index}-${lineIndex}`)}</li>
              ))}
            </ul>
          );
        }

        const singleImageMatch = block.match(SINGLE_IMAGE_PATTERN);
        if (singleImageMatch) {
          return renderNewsImage(singleImageMatch[2], singleImageMatch[1], `block-img-${index}`);
        }

        return <p key={index} className="whitespace-pre-wrap">{renderInline(block, `block-${index}`)}</p>;
      })}
    </div>
  );
};

export default NewsMarkdown;
